<template>
  <div class="container">
    <div class="clearfix">
      <div class="col12">
        <div style="font-weight: 600; padding: 0; margin: 0;">AUCTION SETUP</div>
        <h2 >Updating Delegate Agents</h2>
      </div>
      <div class="col12" style="text-align: right; margin-top: 1em;">
        <v-icon>exit_to_app</v-icon> <router-link to="/dashboard">Exit</router-link>
      </div>
    </div>

    <div v-if="editingDisabled">
      <v-alert outline color="red darken-2" icon="block" :value="true" transition="scale-transition">
        This auction cannot be edited anymore since the status is "{{ auctionStatusLabel(auctionStatus) }}".
      </v-alert>
    </div>

    <div class="create-listing-content">
      <CreateListingDelegate />
    </div>
  </div>
</template>

<script>
  import { auctionStatuses, auctionStatusLabel } from '../utils/PfxUtils.js'

  import CreateListingDelegate from '../components/CreateListingDelegate.vue'

  export default {
    name: 'CreateDelegatePage',
    components: {
      CreateListingDelegate
    },
    data() {
      return {
        auctionStatuses,
        loading: true,
        editingDisabled: false,
      }
    },
    computed: {
      auctionStatus() {
        return this.auction.status
      }
    },
    created() {
      const auctionId = this.$route.params.auctionId || 0
      if (auctionId) {
        this.$store.commit('setDataToNewAuctionStorage', { edit: true })
        this.$store.state.loadingSpinner = true
        this.$PfxBackendApi.getAuction(auctionId).then(res => {
          console.log('getAuction res', res)
          const auction = res.data || {}
          if (auction.status !== auctionStatuses.DRAFT.value && auction.status !== auctionStatuses.OPEN.value
              && auction.status !== auctionStatuses.FREEZE.value) {
            this.editingDisabled = true
          }
        }).catch(err => {
          console.error('getAuction err', err)
          this.$notify({ type: 'danger', message: 'Cannot fetch data about auction with id: ' + auctionId })
        })
      }
    },
    methods: {
      auctionStatusLabel
    }
  }
</script>

<style lang="scss" scoped>

  @import 'node_modules/jeet/scss/index';

  .col12 { @include column(1/2); }

  h2 {
    font-family: 'Encode Sans', sans-serif;
    font-weight: 300;
    font-size: 1.8rem;
    margin: 0 0 .5rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/CreateDelegatePage.vue